import axios from '../utils/axios';

export const addBundle = (body) => {
    return axios.post('/prod/fhir', JSON.stringify(body)).then((response) => {
        return response;
    });
};
